import z from "zod";

// BlobStorage tracks the location of an asset on blob storage
export const BlobStorageSchema = z.object({
	bucket: z.string(),
	key: z.string(),
});
export type BlobStorage = z.infer<typeof BlobStorageSchema>;

// PublicAsset provides metadata about a public asset that was generated
export const PublicAssetSchema = z.object({
	id: z.string(),
	blockId: z.string().optional(),
	chatId: z.string().optional(),
	blob: BlobStorageSchema,
	tenantId: z.string(),
	organizationId: z.string(),
	workspaceId: z.string(),
	projectId: z.string(),
	createdBy: z.string(),
	createdAt: z.string(),
	modifiedBy: z.string(),
	modifiedAt: z.string(),
	isArchived: z.boolean(),
});
export type PublicAsset = z.infer<typeof PublicAssetSchema>;

// Params for getting a public asset by ID
export const AssetIdParamsSchema = z.object({
	assetId: z.string(),
});
export type AssetIdParams = z.infer<typeof AssetIdParamsSchema>;

// Params for getting a public asset by block ID
export const BlockIdParamsSchema = z.object({
	blockId: z.string(),
});
export type BlockIdParams = z.infer<typeof BlockIdParamsSchema>;

// Request body for creating a public asset
export const CreatePublicAssetRequestSchema = z.object({
	markdown: z.string(),
	blockId: z.string().optional(),
	chatId: z.string().optional(),
});
export type CreatePublicAssetRequest = z.infer<typeof CreatePublicAssetRequestSchema>;
